<template>
  <q-page class="column" v-if="this.component">
    <q-toolbar class="bg-secondary text-white">
      <q-btn flat dense icon="publish"></q-btn>
      <q-btn flat dense icon="alarm" disabled/>
      <!--<q-btn flat dense :icon="'border_' + layoutOrientation" @click="switchOrientation"/>-->
      <!--<q-btn flat dense icon="settings" @click="showEditorSettings"/>-->

      <q-input dark
               color="secondary"
               v-model="component.name" :style="{'font-size': '6mm', width: '25%'}"
               flat
               dense
               @input="titleChanged"></q-input>
      <q-toolbar-title>
      </q-toolbar-title>

      <q-btn-group>
        <q-btn v-for="split in Object.values(splits)" :key="split.index"
            :color="split.visible ? (split.locked ? 'primary' : 'white') : 'secondary'"
            :text-color="split.visible ? 'secondary' : 'white'"
            :icon="split.icon"
            @click="clickSetSplit(split)" />
      </q-btn-group>
      <q-btn-dropdown color="secondary" :label="maxEditors" small class="q-ml-sm">
        <q-list link>
          <q-item v-for="n in 6" :key="`1.${n}`" v-close-popup @click.native="maxEditors = n; closeExtraSplits(); recreateSplits()">
            <q-item-main>
              <q-item-label>{{n}}</q-item-label>
            </q-item-main>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </q-toolbar>

    <div class="row no-wrap overflow-hidden col">
      <div v-for="(editorInfo, editor) in splits" v-if="editor !== 'preview'" :key="editor"
           :id="'cm' + editor + 'div'" v-show="editorInfo.visible" class="column">
        <q-toolbar class="bg-primary text-white">
          <q-toolbar-title>
            <q-icon :name="editorInfo.icon"/>
            {{editorInfo.name}}
          </q-toolbar-title>
        </q-toolbar>
        <ace-editor :ref="'cm' + editor"
                    :options="cmOpts(editor)"
                    @change="codeChange(editor, ...arguments)"
                    :content="editor === 'errors' ? componentLog : (editorInfo.data||component.code[editor])"
                    :sync="editor === 'errors'"
                    class="col">
        </ace-editor>
      </div>
      <div id="cmpreviewdiv" v-show="splits['preview'].visible">
        <q-toolbar class="row bg-primary text-white">
          <q-toolbar-title>
            <q-icon name="far fa-newspaper"/>
            Preview
          </q-toolbar-title>
        </q-toolbar>
        <q-scroll-area class="allow-touch col" style="height: 100%; width: 100%; overflow: hidden;" ref="contentScroller">
          <div class="q-ma-md render-container" v-html="renderedMd"></div>
        </q-scroll-area>
      </div>
    </div>
  </q-page>
</template>

<script>
// import componentJsTernDefs from '../docs/component/js'
import * as ace from 'ace-builds/src-noconflict/ace'
import Split from 'split.js'
import { resetCustomMd, updateCustomMd } from '../js/customMdParse/customMdParse'
import { ComponentDefinition } from '../js/customMdParse/ComponentDefinition'
import { updateComponentHtmlInDOM } from '../js/customMdParse/components'
import componentHelper from '../js/customMdParse/componentHelper'

export default {
  // name: 'PageName',
  data () {
    return {
      layoutOrientation: 'horizontal',
      splits: {
        html: { visible: false, size: 20, index: 0, icon: 'fab fa-html5', locked: false, name: 'HTML', data: null },
        css: { visible: false, size: 20, index: 1, icon: 'fab fa-css3', locked: false, name: 'CSS', data: null },
        js: { visible: true, size: 20, index: 2, icon: 'fab fa-js', locked: false, name: 'JS', data: null },
        md: { visible: false, size: 20, index: 3, icon: 'fas fa-asterisk', locked: false, name: 'Regex', data: null },
        userData: { visible: false, size: 20, index: 4, icon: 'mdi-code-braces', locked: false, name: 'User Data', data: null },
        desc: { visible: false, size: 20, index: 5, icon: 'mdi-markdown', locked: false, name: 'Description', data: null },
        preview: { visible: true, size: 20, index: 6, icon: 'far fa-newspaper', locked: true, name: 'Preview', data: null },
        errors: { visible: true, size: 20, index: 7, icon: 'error', locked: true, name: 'Errors', data: '' }
      },
      splitter: null,
      item: {
        id: '00000000000000',
        data: '',
        userData: {}
      },
      component: null,
      ternServer: null,
      maxEditors: 3,
      renderedCache: '',
      curCmp: null,
      renderedMd: null,
      componentDefinitionAry: [],
      jsErr: null,
      jsMarkers: [],
      jsMarker: null
    }
  },
  computed: {
    componentLog () {
      return this.$store.state.ui.componentLog
    },
    componentInStore () {
      if (this.component == null) return null
      return this.$store.state.components.components[this.$route.params.id]
    },
    defaultEditorSettings () {
      let editorSettings = this.$store.state.auth.currentUser.settings.editor
      let defaultOpts = {
        navigateWithinSoftTabs: true,
        animatedScroll: true,
        showInvisibles: false, // TODO: add setting
        printMargin: false,
        fontSize: '10px',
        // fontFamily: '',
        // scrollPastEnd: 0.5,
        // theme: 'ace/theme/',
        overwrite: false, // TODO: add setting
        newLineMode: 'auto', // "auto" | "unix" | "windows"
        useSoftTabs: true,
        useWorker: true,
        tabSize: 2,
        wrap: 'free',
        theme: 'default',
        foldStyle: 'markbegin' // "markbegin"|"markbeginend"|"manual"
      }
      if (this.$store.state.auth.currentUser == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings == null) return defaultOpts
      if (this.$store.state.auth.currentUser.settings.editor == null) return defaultOpts
      return Object.assign(defaultOpts, editorSettings)
    }
  },
  watch: {
    componentInStore (newVal) {
      if (this.$_.isEqual(this.component, newVal)) return
      console.log('Component in store changed!!!!')
      console.log(this.component)
      console.log(newVal)
      // TODO: add a comparison, show the user what has changed!!
      this.$q.dialog({
        title: 'Component updated',
        message: 'This component was just updated remotely.  Would you like to use their changes or keep yours?',
        ok: {
          label: 'Use their version'
        },
        cancel: {
          label: 'Keep my version'
        },
        preventClose: true
      }).onOk(() => {
        this.pullLocalComponentFromStore(this.component.id)
      }).onCancel((err) => {
        console.log('Local version kept, remote version ignored: ' + err.toString())
      })
    }
  },
  methods: {
    // performLintJs () {
    //   this.$refs.cmjs[0]._data.codemirror.performLint()
    // },
    // getJsLintAnnotations () {
    //   if (!this.jsErr) {
    //     return []
    //   }
    //   console.log(this.jsErr.line)
    //   return [{message: this.jsErr.msg.slice(22), severity: 'error', from: CodeMirror.Pos(this.jsErr.line - 2, this.jsErr.col - 1), to: CodeMirror.Pos(this.jsErr.line - 2, 10000)}]
    // },
    cmOpts (editor) {
      let editorSettings = Object.assign({}, this.defaultEditorSettings)
      switch (editor) {
        case 'html':
          editorSettings.mode = 'ace/mode/html'
          editorSettings.matchTags = true
          break
        case 'js':
          editorSettings.mode = 'ace/mode/javascript'
          break
        case 'css':
          editorSettings.mode = 'ace/mode/css'
          editorSettings.matchBrackets = true
          break
        case 'md':
          editorSettings.mode = 'ace/mode/markdown'
          break
        case 'userData':
          editorSettings.mode = 'ace/mode/json'
          break
        case 'desc':
          editorSettings.mode = 'ace/mode/markdown'
          break
        case 'errors':
          editorSettings.mode = 'ace/mode/text'
          // editorSettings.readOnly = true
          break
      }
      return editorSettings
    },
    genCmpDefAry () {
      if (this.component == null) return []
      console.log('update component def ary ce')
      this.curCmp = new ComponentDefinition( // eslint-disable-line vue/no-side-effects-in-computed-properties
        this.component.id,
        this.component.name,
        this.component.code.md,
        this.component.code.css,
        this.component.code.html,
        this.component.code.js,
        this.component.code.scripts,
        this.component
      )
      resetCustomMd()
      this.componentDefinitionAry = [this.curCmp]
    },
    render () {
      if (this.$store.state.ui.skipMdRender) {
        console.log('skiprender')
        this.$store.commit('setSkipMdRender', false)
        return this.renderedMd
      }
      console.log('rendered!!')
      let curPos = null
      // if (this.codemirror() && this.codemirror().hasFocus() && !this.$q.platform.is.mobile) {
      //   curPos = this.codemirror().indexFromPos(this.codemirror().getCursor())
      // }
      this.jsErr = null
      componentHelper.clearlog()
      componentHelper.log(`Compiling template for ${this.component.name} ...`)
      try {
        this.renderedMd = updateCustomMd(this.item.data || '', this.componentDefinitionAry, this.item, curPos, false, this.saveThrottledAndUpdateDesc)
        updateComponentHtmlInDOM()
      } catch (err) {
        if (err.msg.startsWith('Uncaught SyntaxError')) {
          this.jsErr = err
          this.$q.notify({
            message: 'Error Compiling Template',
            color: 'negative'
          })
          window.$ch.log(err.msg)
          // this.splits.errors.data += err.error.stack + '\n'

          // const editor = this.$refs['cm' + 'js'][0].editor
          // const start = editor.session.getDocument().pos(err.line, err.col)
          // const end = editor.session.getDocument().pos(err.line, err.col + 1)
          // let range = new ace.Range()
          // range.start = start
          // range.end = end
          // // console.log(range)
          // if (this.jsMarker) editor.session.removeMarker(this.jsMarker)
          // this.jsMarker = editor.session.addMarker(
          //   range,
          //   'warning',
          //   'text',
          //   true
          // )
        }
      }
      componentHelper.log('Compiled.')
      // this.performLintJs()
    },
    saveNow () {
      // Clear any pending saves
      clearTimeout(this.saveTimeout)
      this.saveTimeout = null
      // Check item exists
      if (this.component == null) {
        console.log('Could not save component ' + this.$route.params.id)
        return Promise.all([])
      }
      // Check that there are changes to save
      if (!this.unsavedChanges) {
        return Promise.all([])
      }
      console.log('Saving component ' + this.component.id)
      this.component.updatedAt = new Date()
      return this.$store.dispatch('updateComponent', this.component)
    },
    /**
     * Save with a timeout
     * @param saveDelayMs ms to delay before saving
     */
    saveThrottled (saveDelayMs) {
      this.unsavedChanges = true
      clearTimeout(this.saveTimeout) // Reset timer (ie. delay save to 1s from now instead of whatever the timeout value was)
      this.saveTimeout = setTimeout(() => {
        this.saveNow()
      }, saveDelayMs || 2000)
    },
    /**
     * Save with a timeout
     * @param saveDelayMs ms to delay before saving
     */
    saveThrottledAndUpdateDesc (saveDelayMs) {
      this.component.code.desc = this.item.data
      this.component.code.userData = this.item.userData
      this.splits.userData.data = JSON.stringify(this.component.code.userData, null, 2)
      this.updateEditorValues()
      // this.saveThrottled(saveDelayMs)
    },
    updateEditorValues () {
      Object.keys(this.splits).forEach(editor => {
        if (!this.$refs['cm' + editor]) return
        this.$refs['cm' + editor][0].setValue(this.splits[editor].data || this.component.code[editor])
      })
    },
    codeChange (editor, newVal) {
      if (this.component.code[editor] === newVal) return
      if (editor === 'errors') return
      this.component.code[editor] = newVal

      if (editor === 'desc') {
        this.item.data = newVal
      } else if (editor === 'userData') {
        let data = JSON.parse(newVal)
        this.item.userData = data
        this.component.code['userData'] = data
      } else {
        this.throttledGenCmpDefAry()
      }
      this.throttledRender()

      this.saveThrottled()
    },
    switchOrientation () {
      // TODO: not working!
      if (this.layoutOrientation === 'horizontal') {
        this.layoutOrientation = 'vertical'
      } else {
        this.layoutOrientation = 'horizontal'
      }
      this.recreateSplits()
    },
    checkZeroWidthSplits () {
      let needsUpdate = false
      let sizes = this.splitter.getSizes()
      let openSplits = this.$_.sortBy(this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? v : null }), null), 'index')
      sizes.forEach((s, i) => {
        if (s < 1) {
          openSplits[i].visible = false
          needsUpdate = true
        }
      })
      if (needsUpdate) this.recreateSplits()
    },
    updateEditorWrapping (editorName) {
      if (this.$refs[editorName] === undefined) return
      let editor = this.$refs[editorName][0].editor
      let characterWidth = editor.renderer.characterWidth
      let contentWidth = editor.renderer.scroller.clientWidth
      editor.session.setWrapLimit(parseInt(contentWidth / characterWidth - 1, 10))
    },
    refreshVisibleEditors () {
      this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? 'cm' + k : null }), null).forEach(en => {
        if (en === 'cmpreview') return
        this.updateEditorWrapping(en)
      })
    },
    recreateSplits (preserveWidths) {
      let selectors = this.$_.without(this.$_.map(this.splits, (v, k) => { return v.visible ? '#cm' + k + 'div' : null }), null)
      let widths = null

      if (preserveWidths && this.splitter) {
        widths = this.splitter.getSizes()
      }

      if (this.splitter) {
        this.splitter.destroy()
      }

      let t = this
      this.splitter = Split(selectors, {
        sizes: widths,
        minSize: 0,
        gutterSize: 8,
        direction: this.layoutOrientation,
        onDragEnd: function () {
          // localStorage.setItem('split-sizes', JSON.stringify(split.getSizes()));
          t.checkZeroWidthSplits()
          t.refreshVisibleEditors()
        }
      })
      this.$nextTick(() => {
        t.refreshVisibleEditors()
      })
    },
    visibleSplits () {
      return this.$_.countBy(this.splits, 'visible')[true]
    },
    visibleUnlockedSplits () {
      return this.$_.pickBy(this.splits, s => s.visible && !s.locked)
    },
    closeExtraSplits (aboutToOpen) {
      while (this.visibleSplits() + (aboutToOpen ? 1 : 0) > this.maxEditors) { // eslint-disable-line no-unmodified-loop-condition
        this.splits[Object.keys(this.visibleUnlockedSplits())[0]].visible = false
        // this.splits[this.$_.findKey(this.splits, ['visible', true])].visible = false
      }
    },
    clickSetSplit (split) {
      if (!split.visible) {
        if (Object.keys(this.visibleUnlockedSplits()).length + 1 <= this.maxEditors) {
          this.setSplitVisible(split, 'true')
        }
      } else if (split.visible && !split.locked) {
        split.locked = true
      } else {
        split.locked = false
        this.setSplitVisible(split, false)
      }
    },
    setSplitVisible (split, visible) {
      if (visible === 'toggle') visible = !split.visible
      let preserveWidths = false
      let openSplits = this.visibleSplits()
      // Not allowed to turn all splits off.  Must keep at least one!
      if (openSplits === 1 && !visible) return
      this.closeExtraSplits(visible)
      split.visible = visible
      if (this.visibleSplits() === openSplits) preserveWidths = true // Same number of splits?
      this.recreateSplits(preserveWidths)
    },
    titleChanged (newVal) {
      this.component.name = newVal.trim()
      this.saveThrottled()
    },
    // updateArgHints (editor, cm) {
    //   this.ternServer.updateArgHints(cm)
    // },
    // TODO: Maybe this isn't so useful in JS?  Add an option to turn it on/off?
    // TODO: Add this functionality to main page markdown render!!!
    // TODO: Automatically replace all tabs in all docs with spaces!!!!!!
    // cmWrapLineOnRender (editor, cm, line, elt) {
    //   let basePadding = 4
    //   let charWidth = cm.defaultCharWidth()
    //   let off = CodeMirror.countColumn(line.text, null, cm.getOption('tabSize')) * charWidth
    //   let equalsIndex = line.text.indexOf('=')
    //   if (equalsIndex > -1) {
    //     off = ((equalsIndex + 2) * charWidth)
    //   }
    //   elt.style.textIndent = '-' + off + 'px'
    //   elt.style.paddingLeft = (basePadding + off) + 'px'
    // },
    pullLocalComponentFromStore (componentId) {
      this.component = this.$_.cloneDeep(this.$store.state.components.components[componentId])
      if (this.component == null) this.$router.replace('/components')
      this.item.data = this.component.code.desc
      this.item.userData = this.component.code.userData
      this.splits.userData.data = JSON.stringify(this.component.code.userData, null, 2)
      this.unsavedChanges = false
      this.$nextTick(() => {
        this.recreateSplits(true)
        resetCustomMd()
        this.genCmpDefAry()
        this.render()
        this.updateEditorValues()
      })
    }
  },
  mounted () {
    // this.ternServer = new CodeMirror.TernServer({defs: [this.$_.cloneDeep(componentJsTernDefs)]})
    this.throttledGenCmpDefAry = this.$_.debounce(this.genCmpDefAry, 2000)
    this.throttledRender = this.$_.debounce(this.render, 2000)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.pullLocalComponentFromStore(vm.$route.params.id)
    })
  },
  beforeRouteLeave (to, from, next) {
    this.saveNow().then(() => {
      next()
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.saveNow().then(() => {
      this.pullLocalComponentFromStore(to.params.id)
      next()
    })
  }
}
</script>

<style lang="styl">
  .render-container {
    h1:first-child {
      font-size: 40px;
      margin-bottom: 20px;
    }
  }

  .split-horizontal {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .split-vertical {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .gutter {
    background-color: #eee;
    background-repeat: no-repeat;
    background-position: 50%;
  }

  .gutter.gutter-horizontal {
    cursor: col-resize;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==');
  }

  .gutter.gutter-vertical {
    cursor: row-resize;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');
  }

  .split.split-horizontal, .gutter.gutter-horizontal {
    /*height: 300px;*/
    float: left;
  }
</style>
